import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/', component: (resolve) => require(['../components/box'], resolve), children: [
        { path: '/', redirect: '/rubbish' },
        { path: '/rubbish', meta: { title: '危废管理'}, component: (resolve) => require(['../components/rubbish'], resolve), },
        { path: '/rubbish/details', meta: { title: '危废详情', keepAlive: false }, component: (resolve) => require(['../components/rubbish/details'], resolve), },
        { path: '/end', meta: { title: '已入仓'}, component: (resolve) => require(['../components/end'], resolve), },
        { path: '/demo', meta: { title: '小样管理'}, component: (resolve) => require(['../components/demo'], resolve), },
        { path: '/demo/details', meta: { title: '小样详情', keepAlive: false }, component: (resolve) => require(['../components/demo/details'], resolve), },
        { path: '/setting/personal', meta: { title: '个人中心' }, component: (resolve) => require(['../components/setting/personal'], resolve), },
        { path: '/setting/user', meta: { title: '用户管理' }, component: (resolve) => require(['../components/setting/user'], resolve), },
      ]
    },
    { path: '/rubbish/qrcode', meta: { title: '二维码打印' }, component: (resolve) => require(['../components/rubbish/qrcode'], resolve), },
    { path: '/login', meta: { title: '登录', keepAlive: false }, component: (resolve) => require(['../components/login'], resolve), },
    // 404
    { path: '/404', name: '404', meta: { title: '404' }, component: (resolve) => require(['../components/404'], resolve) },
    { path: '*', name: '404', meta: { title: '404' }, component: (resolve) => require(['../components/404'], resolve) },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js